import { render, staticRenderFns } from "./BcFileUpload.vue?vue&type=template&id=6df87f5e&scoped=true"
import script from "./BcFileUpload.vue?vue&type=script&lang=js"
export * from "./BcFileUpload.vue?vue&type=script&lang=js"
import style0 from "./BcFileUpload.vue?vue&type=style&index=0&id=6df87f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df87f5e",
  null
  
)

export default component.exports